import React, { useState } from "react";
import { deleteSummarypromptData, deleteSummarylength } from "../../../services/AdminService";
import CustomeModal from "./CustomeModal";
import { toast } from "react-toastify";

const DeleteSummaryPrompt = ({ type, ...props }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirmDelete = async () => {
        setLoading(true);
        try {
            await (type === "document" ? deleteSummarypromptData(props.item.id) : deleteSummarylength(props.item.id) )
            toast.success("Summary deleted successfully!");
            props.fetchSummaryData();
            props.handleClose();
        } catch {
            toast.error("Failed to delete summary.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <CustomeModal
            {...props} 
            title="Delete Prompt"
            onConfirm={handleConfirmDelete}
            loading={loading}
            modalType="delete"
        >
            <p>Are you sure you want to delete?</p>
            <strong>{type === "document" ?  props.item?.document_type : props.item?.length_type}</strong>
        </CustomeModal>
    );
};

export default DeleteSummaryPrompt;
